import Client from "../client/Base"
const resource = "/api/v2"

const getTopics = (params) => {
  return Client.get(`${resource}/publish/topic/`, { params })
}

const getChannels = (params) => {
  return Client.get(`${resource}/publish/topic/channel/`, { params })
}

const getBroadcast = (params) => {
  return Client.get(`${resource}/publish/broadcast/`, { params })
}

const updateStatusNoti = (data) => {
  return Client.post(`${resource}/publish/broadcast/`, data)
}

const userRepository = {
  getTopics,
  getChannels,
  getBroadcast,
  updateStatusNoti
}

export default userRepository
